import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';
import { getProfilePrefillAddress } from '../../utils/helpers';
import AddressLines from '../FormFields/AddressLines';
import PrefillCard from '../FormFields/PrefillCard';

const CARD_TITLE = content['sponsor--prefill-address-card-title'];

const SponsorAddressPrefillCard = ({ formData }) => (
  <PrefillCard title={CARD_TITLE} testId="sponsor-address-prefill-card">
    <p
      className="vads-u-margin--0 dd-privacy-hidden"
      data-dd-action-name={CARD_TITLE}
    >
      <AddressLines address={getProfilePrefillAddress(formData)} />
    </p>
  </PrefillCard>
);

SponsorAddressPrefillCard.propTypes = {
  formData: PropTypes.object,
};

export default SponsorAddressPrefillCard;
